export type ConfirmPasswordValue = string | null;
export type OldPasswordValue = string | null;


export type confirmPassword = {
    password?: ConfirmPasswordValue | undefined;
    confirmPassword?: ConfirmPasswordValue | undefined;
    oldPassword?: OldPasswordValue | undefined;
}